import {
    CREATE_MIS_FORM_FIELD_SUCCESS, CREATE_MIS_FORM_FIELD_FAILURE,
    GET_MIS_FORM_FIELD_FILTERED_SUCCESS, GET_MIS_FORM_FIELD_FILTERED_FAILURE,
    MASTER_DATA_LIST_SUCCESS,MASTER_DATA_LIST_FAILURE
} from './action';

const initialState = {
    createMisFormFieldSuccess: {},
    createMisFormFieldFailure: {},
    misFormFieldFilteredList: [],
    misFormFieldFilteredListFailure: [],
    masterDataList:[],
    masterDataListError:null,
}

const misFormFieldReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_MIS_FORM_FIELD_SUCCESS:
            return state = {
                ...state,
                createMisFormFieldSuccess: action.data
            }
        case CREATE_MIS_FORM_FIELD_FAILURE:
            return state = {

                ...state,
                createMisFormFieldFailure: action.data
            }
        case GET_MIS_FORM_FIELD_FILTERED_SUCCESS:
            return state = {

                ...state,
                misFormFieldFilteredList: action.data
            }
        case GET_MIS_FORM_FIELD_FILTERED_FAILURE:
            return state = {

                ...state,
                misFormFieldFilteredListFailure: action.data
            }
        case MASTER_DATA_LIST_SUCCESS:
                return state = {
    
                    ...state,
                    masterDataList: action.data
                }
        case MASTER_DATA_LIST_FAILURE:
                return state = {
    
                    ...state,
                    masterDataListError: action.data
                }
        default: return state
    }
}
export default misFormFieldReducer;